import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenCreditModalComponent } from '../token-credit-modal/token-credit-modal.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { serviceurl } from 'src/app/constant/constant';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from 'src/app/services/data.service';
import { AccountAuthService } from '../../auth/account-auth.service';
import { catchError, of, Subscription } from 'rxjs';
import { AuthServices } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { SubscriptionService } from '../../subscription/services/subscription.service';
import { CartService } from 'src/app/services/marketplace/cart.service';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() pendinginvitationlist: number = 0;
  @Input() headerTitle: string = '';
  user: any;
  ip: string = '';
  // pendinginvitationlist: any;
  userid: any;
  userdata: any;
  hasPaidSubscription: boolean = false;
  /** e.g. "Adventurer plan", under your name in the account menu. */
  planLabel = '';
  pendingInvitationCountSubscription: Subscription;
  currentUserSubscription: Subscription;
  subscriptionCheckSubscription: Subscription;
  cartCountSubscription: Subscription;
  cartCount: number = 0;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private authserv: AuthServices,
    private dataserv: DataService,
    private toastService: ToastService,
    private currentUserService: CurrentUserService,
    private accountAuth: AccountAuthService,
    private cookieService: CookieService,
    private subscriptionService: SubscriptionService,
    private cartService: CartService,
    private cdr: ChangeDetectorRef,
    private storeLink: StoreLinkService,
  ) { }
  get profileImg(): string {
    return this.user?.image
      ? this.ip + this.user.image
      : 'assets/images/profile-img.png';
  }

  get hasNotifications(): boolean {
    return this.pendinginvitationlist > 0;
  }

  get notificationBadge(): string {
    return this.pendinginvitationlist > 9 ? '9+' : String(this.pendinginvitationlist);
  }

  get cartAriaLabel(): string {
    if (this.cartCount <= 0) {
      return 'Cart, empty';
    }
    return `Cart, ${this.cartCount} item${this.cartCount === 1 ? '' : 's'}`;
  }

  get notificationAriaLabel(): string {
    const count = this.pendinginvitationlist;
    if (count <= 0) {
      return 'Notifications, none unread';
    }
    if (count === 1) {
      return 'Notifications, 1 unread';
    }
    return `Notifications, ${count} unread`;
  }

  ngOnDestroy(): void {
    this.currentUserSubscription?.unsubscribe();
    this.pendingInvitationCountSubscription?.unsubscribe();
    this.subscriptionCheckSubscription?.unsubscribe();
    this.cartCountSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.ip = serviceurl;
    this.cartCountSubscription = this.cartService.count$.subscribe((count) => {
      this.cartCount = count;
      this.cdr.detectChanges();
    });
    this.currentUserSubscription =
      this.currentUserService.currentUser.subscribe((data) => {
        if (data) {
          this.user = data;
          this.userid = data.id;
          this.getProfile();
          this.checkSubscriptionStatus();
          // Only ever hit the cart endpoint for a signed-in user — it is
          // IsAuthenticated, and an anonymous 401 would trip ErrorInterceptor's
          // redirect to /login from whatever page merely rendered the header.
          this.cartService.refreshCount();
        } else {
          this.hasPaidSubscription = false;
          this.cartService.clearCount();
        }
        this.cdr.detectChanges();
      });
    this.pendingInvitationCountSubscription =
      this.currentUserService.count$.subscribe((count: number) => {
        this.pendinginvitationlist = count;
        console.log('Pending Invitations:', count);
        this.cdr.detectChanges();
      });
  }

  /**
   * Check if user has a paid subscription to show "Manage Subscription" instead of "Subscription"
   */
  private checkSubscriptionStatus(): void {
    if (!this.userid) {
      this.hasPaidSubscription = false;
      return;
    }

    this.subscriptionCheckSubscription = this.subscriptionService
      .getCurrentSubscription(this.userid)
      .pipe(
        catchError(() => {
          this.hasPaidSubscription = false;
          return of(null);
        }),
      )
      .subscribe((planRes: any) => {
        if (planRes && planRes.plan) {
          const planName = (planRes.plan || '').toString().toLowerCase();
          this.hasPaidSubscription = planName && planName !== 'adventurer';
          this.planLabel = planName ? planName.charAt(0).toUpperCase() + planName.slice(1) + ' plan' : '';
        } else {
          this.hasPaidSubscription = false;
          this.planLabel = '';
        }
        this.cdr.detectChanges();
      });
  }

  /**
   * Navigate to subscription plans page (always show plans, not redirect to portal)
   */
  navigateToSubscription(): void {
    // Always navigate to subscription page with showPlans=true to display the pricing table
    this.router.navigate(['/subscription'], {
      queryParams: {
        isUser: true,
        showPlans: true,
      },
    });
  }

  loginWithRedirect() {
    this.router.navigate(['/login']);
  }

  getProfile() {
    this.authserv.currentUserData(this.userid).subscribe((data: any) => {
      sessionStorage.setItem('currentUser', JSON.stringify(data));
    
          this.cdr.detectChanges();});
  }

  refreshProfileImage(event: any): void { }

  redirectToSignUp() {
    this.accountAuth.signOut('/signup');
  }

  openinvitationpage() {
    this.router.navigate(['/invitationpage']);
  }

  openTokenCreditWindow() {
    const modalRef = this.modalService.open(TokenCreditModalComponent, {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'lg',
      windowClass: 'wt-sheet-modal',
    });
  }

  logout() {
    this.accountAuth.signOut(null);

    // A fresh start on the landing page, so nothing from the session lingers
    // in memory.
    window.location.assign(new URL('home', document.baseURI).href);
  }
}
